import axios from 'axios'

export const getStat = (id, forceUpdate) => {
  return axios.get(`/apis/v1/tasks/stats/${id}`, {
    params: {
      force_update: forceUpdate
    }
  })
}
